document.addEventListener('DOMContentLoaded', function () {
    // Accordion Logic
    const accItems = document.querySelectorAll('.sv2-acc-item');

    accItems.forEach(item => {
        const header = item.querySelector('.sv2-acc-header');

        const openAccordion = function () {
            if (item.classList.contains('active')) return; // already open

            const content = item.querySelector('.sv2-acc-content');
            const plus = item.querySelector('.plus');
            const minus = item.querySelector('.minus');

            // Close other items
            document.querySelectorAll('.sv2-acc-item').forEach(other => {
                if (other !== item) {
                    other.classList.remove('active');
                    other.querySelector('.sv2-acc-content').style.display = 'none';
                    other.querySelector('.plus').style.display = 'block';
                    other.querySelector('.minus').style.display = 'none';
                }
            });

            // Open current item
            item.classList.add('active');
            content.style.display = 'block';
            plus.style.display = 'none';
            minus.style.display = 'block';

            // Re-initialize or refresh slick slider when becoming visible
            if (typeof jQuery !== 'undefined') {
                const slider = jQuery(content).find('.sv2-slider');
                if (slider.hasClass('slick-initialized')) {
                    setTimeout(() => {
                        slider.slick('setPosition');
                    }, 150);
                }
            }
        };

        // Open on click
        header.addEventListener('click', function () {
            // If it's already active and they click, maybe they want to close it? 
            // Or let's keep it standard: click always opens, or closes if open.
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                item.querySelector('.sv2-acc-content').style.display = 'none';
                item.querySelector('.plus').style.display = 'block';
                item.querySelector('.minus').style.display = 'none';
            } else {
                openAccordion();
            }
        });

        // Open on hover
        item.addEventListener('mouseenter', function () {
            openAccordion();
        });
    });

    // Initialize Slick Slider
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        const svgArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19" fill="none"><path d="M-0.000959221 1.5458L1.50212 -3.16458e-05L9.68904 8.42476C9.82101 8.55975 9.92574 8.72028 9.99721 8.89711C10.0687 9.07393 10.1055 9.26356 10.1055 9.45507C10.1055 9.64659 10.0687 9.83622 9.99721 10.013C9.92574 10.1899 9.82101 10.3504 9.68904 10.4854L1.50212 18.9145L0.000454219 17.3687L7.68446 9.45726L-0.000959221 1.5458Z" fill="white"/></svg>`;
        const prevArrow = `<button type="button" class="sv2-slick-prev" aria-label="Previous" style="position: absolute; top: 50%; left: -30px; transform: translateY(-50%) rotate(180deg); z-index: 10; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background-color: #8c8c8c; border: none; border-radius: 50%;">${svgArrow}</button>`;
        const nextArrow = `<button type="button" class="sv2-slick-next" aria-label="Next" style="position: absolute; top: 50%; right: -30px; transform: translateY(-50%); z-index: 10; cursor: pointer; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background-color: #8c8c8c; border: none; border-radius: 50%;">${svgArrow}</button>`;
        
        jQuery('.sv2-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 1 }
                }
            ]
        });
    } else {
        // Slick Slider is not loaded, fail silently to avoid console spam
    }
});